import { Move } from '@rlmoves/api';
import { CanLeak } from '../mixins';

export abstract class GifPlayer extends CanLeak {
  abstract move: Move;
  abstract close(): void;
}
